<template>
  <div class="d-flex align-items-center mb-2" @click="goBack()">
    <div class="header-button" >
      <i class="ph-custom ph-caret-left-fill"/>
    </div>
    <h1 class="page-title link ml-1">{{title}}</h1>
  </div>

</template>

<script>

import i18n from '../../i18n'

export default {
  name: 'BackArrow',

  components: {
    i18n
  },

  props: {
    title: {
      type: String,
      default: i18n.t('Back')
    },
    routeBack: {
      type: String,
      default: null
    }
  },
  methods: {
    goBack () {
      if (this.routeBack) {
        this.$router.push({
          name: this.routeBack
        })
      }
      else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped>
.header-button-line {
  flex-direction: row;
}
.header-button {
  background-color: var(--main-green-light);
  border-radius: 10px;
  height: 36px;
  width: 36px;
  min-width: 36px;
  margin-right: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  color : var(--main-color-dark)
}

.header-button:hover {
  cursor: pointer;
  background-color: var(--main-color-medium);
  /*color: var(--main-white);*/
}
.link:hover{
  cursor: pointer;
  /*color: var(--main-color-medium);*/
}

</style>



// WEBPACK FOOTER //
// src/components/b122/BackArrow.vue